import { render } from "./paymentCardList.vue?vue&type=template&id=138f66cc"
import script from "./paymentCardList.vue?vue&type=script&lang=js"
export * from "./paymentCardList.vue?vue&type=script&lang=js"

import exportComponent from "F:\\CodeBrix\\My Porter\\WECCO-UserFlow\\MyPorter\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__